export default __webpack_public_path__ + "static/media/Iphone-render-mobile-min.e98e32ea.png";